import {Component, HostListener, OnDestroy, OnInit} from '@angular/core';
import {UrlService} from '../../services/url.service';
import {UserStatisticsService} from '../../services/user-statistics.service';

@Component({
    templateUrl: 'user-statistics.component.html',
    styleUrls: ['user-statistics.component.scss'],
})
export class UserStatisticsComponent implements OnInit, OnDestroy {

    constructor(public userStatisticsService: UserStatisticsService,
                public urlService: UrlService) {
    }

    ngOnInit() {
        this.userStatisticsService.getBuildings();

        this.urlService.onUrlChange.subscribe(() => {
            this.userStatisticsService.tabId = this.urlService.queryParams['tab'];
            this.userStatisticsService.showDetailedView = false;
            this.userStatisticsService.selectedItemData = null;
            this.userStatisticsService.getData(true);
        });
        this.urlService.setQueryParams('allKeyLogs');
    }

    ngOnDestroy() {
        this.removeAllObservers();
        this.userStatisticsService.resetData();
        this.urlService.resetQueryParams();
    }

    removeAllObservers() {
        this.urlService.onUrlChange.observers = [];
    }

    changeBuilding(event) {

    }

    buildingsToSearchSelect(data) {
        return data.map(i => ({...i, optionText: i.name}));
    }

    changeFilter() {

    }

    @HostListener('window:resize', ['$event'])
    onResize() {
        this.userStatisticsService.emptyRowService.fillEmptyRow();
    }
}





// WEBPACK FOOTER //
// /app/src/app/views/user-statistics/user-statistics.component.ts